let platform = 'app';

module.exports = {
  init: p => {
    platform = /^app|web$/i.test(p) ?
    p.toLowerCase() : 'app';
  },
  get() {
    return platform;
  },
  is(p) {
    return p.toLowerCase() === platform;
  },
  get web() {
    return platform === 'web';
  },
  get app() {
    return platform === 'app';
  }
};
